import NewSurveyConfig from "./NewSurveyConfig";

export default NewSurveyConfig;
